import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesCargoIdsMain } from './modules/ui/Main';

const CargoIdsPage = (
  <SuspensePage>
    <PagesCargoIdsMain />
  </SuspensePage>
);

export default CargoIdsPage;
